/* eslint-disable no-constant-binary-expression */
import { FC } from 'react';
import groupMembersIcon from 'assets/icons/group-members-icon.svg';
import { clsx } from 'clsx';

import { ICardTeacherScheduleProps } from '../models/types';

import styles from './styles.module.scss';

export const CardTeacherSchedule: FC<ICardTeacherScheduleProps> = ({
  data,
}) => {
  return (
    <div className={styles['card-schedule']}>
      <div className={styles['card-schedule__container']}>
        <div
          className={clsx(
            styles['card-schedule__row'],
            styles['card-schedule__row-1'],
          )}
        >
          <div className={styles['card-schedule__type-tag__wrapper']}>
            <span className={styles['card-schedule__disctype']}>
              {data.disciplType}
            </span>
          </div>
          <span className={styles['card-schedule__disctime']}>
            {data.disciplTime}
          </span>
        </div>
        {data.subgroupNum && (
          <div className={styles['card-schedule__subgroup']}>
            Подгруппа {data.subgroupNum}
          </div>
        )}
        <div
          className={clsx(
            styles['card-schedule__row'],
            styles['card-schedule__row-2'],
          )}
        >
          <span className={styles['card-schedule__discname']}>
            {data.disciplName}
          </span>
        </div>
        <div
          className={clsx(
            styles['card-schedule__row'],
            styles['card-schedule__row-3'],
          )}
        >
          <span className={styles['card-schedule__building-auditory']}>
            {data.location}
          </span>
        </div>
        {!!data.groupsTags?.length && (
          <div className={styles['card-schedule__tags']}>
            {data.groupsTags.map((tag) => {
              return (
                <div className={styles['card-schedule__tag']} key={tag}>
                  <img src={groupMembersIcon} alt="groupMember" />
                  {tag}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};
